import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelectedChallengesPipe } from './selectedChallenges.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [SelectedChallengesPipe],
    providers: [SelectedChallengesPipe],
    exports: [SelectedChallengesPipe],
})
export class SelectedChallengesPipeModule {}
